import React from 'react'
import { Grid, Row } from 'react-bootstrap'

import Breadcrumbs from '../../components/Breadcrumbs'

export default class NotFound extends React.Component {

  render() {
    return <Grid>
      <Breadcrumbs title='Pagina niet gevonden' />
      <Row>
        <div className='content'>
          <h1>404 - Pagina niet gevonden</h1>
          <p>De pagina die u zoekt bestaat niet.</p>
        </div>
      </Row>
    </Grid>
  }
}
